// extracted by mini-css-extract-plugin
module.exports = {"history-list-item":"HistoryListItem_history-list-item__3L4Sm","location-section":"HistoryListItem_location-section__x79Bo","caption":"HistoryListItem_caption__PWRA-"};